import $ from 'jquery';
import 'slick';
import { 
    slickCommonOptions,
} from './../../scripts/config';

/**
 * SliderV6 widget configs
 */
const sliderV6Semantics = {
    'mainWrapClass': 'slider-v6__wrap',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'commonPluginOptionsAttribute': 'data-common-plugin-options',
    'controlPrevClass': 'slider-v6__prev',
    'controlNextClass': 'slider-v6__next',
    'sliderElementClass': 'slider-v6__list-place',
    'slideClass': 'slick-slide',
};

/**
 * SliderV6 initializer
 */
$(function () {

    if ($(`.${sliderV6Semantics.mainWrapClass}`).length === 0) {
        return false;
    }

    let sliderV6 = new SliderV6();

    /**
     * Checking other instances
     */
    $(`.${sliderV6Semantics.mainWrapClass}`).each((index, el) => {
        let isInitialized =
            ($(el).attr(`${sliderV6Semantics.isInitializedAttribute}`) === 'true');
        if (!isInitialized) {
            sliderV6.registerInstance($(el));
            sliderV6.registerListeners($(el));
        }
    });

});

class SliderV6 {
    // not install @babel/plugin-proposal-class-properties
    // init properties in constructor
    constructor() {
        this.pluginInstances = {};
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId =
            el.attr(`${sliderV6Semantics.instanceIdAttribute}`) || false;
        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }
        let commonPluginOptions =
            el.data(
                `${sliderV6Semantics.commonPluginOptionsAttribute}`.replace('data-', '')
            ) || {};

        let pluginOptions = Object.assign({},
            slickCommonOptions,
            commonPluginOptions,
            {
                arrows: false,
                dots: false,
                variableWidth: true,
                mobileFirst: true,
                swipeToSlide: true,
                infinite: true,
            }
        );
        el.show();
        try {
            // TODO[dependDetected]: slick plugin
            // the better solution: impl pluginProvider
            let slick = el.find(
                `.${sliderV6Semantics.sliderElementClass}`
            ).slick(pluginOptions);
            el.attr(`${sliderV6Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = slick;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    registerListeners(el) {
        this.setEqualHeight();
        $(window).on('resize', this.setEqualHeight);
    }

    setEqualHeight() {
        $(`.${sliderV6Semantics.mainWrapClass}`).each(function () {
            let maxHeight = 0;
            let slides = $(this).find(`.${sliderV6Semantics.slideClass}`);
            slides.each(function () {
                let thisHeight = $(this).outerHeight();
                if (thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });
            slides.css('height', maxHeight + 'px');
        });
    }

}